import React from 'react';
import { BrowserRouter as Router, Link, Route } from 'react-router-dom';

function CardItem(props) {
  return (
    <>
      <div className='cards__item'>
        <li className='cards__item__link'>
          <Link to={props.path}>
            <figure className='cards__item__pic-wrap' data-category={props.label}>
              <img
                className='cards__item__img'
                alt='Cards Image'
                src={props.src}
              />
            </figure>
          </Link>
          <div className='cards__item__info'>
            <h5 className='cards__item__text'>{props.text}</h5>
          </div>
        </li>
      </div>
    </>
  );
}

export default CardItem;
